import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import jssVariables from "../../jss_setup";
import { TranslationContext } from "../../umbilical_tools";
import { itemStyles, menuItemStyles } from "../NavBar";
import PropTypes from "prop-types";
import { getMainPromoGenSectionsSelector } from "../../selectors";
import { getProductCategoriesSelector } from "../../umbilical_hocs";

export const linksData = [
  ["hotels", "hotel_packages", "ACC"],
  ["packages", "packages", "PKG"],
  ["tours", "tours", "MI"],
  ["dining", "dining", "REST"],
];

const styles = createUseStyles({
  item: (props: { customStyles: { item: { smallscreen: object } } }) => ({
    ...itemStyles,
    ...(props?.customStyles?.item ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    item: (props: { customStyles: { item: { smallscreen: object } } }) => ({
      display: "grid",
      gridTemplateColumns: "auto auto",
      ...(props?.customStyles?.item?.smallscreen ?? {}),
    }),
  },
});
export function ProductTypeSectionsLinks({
  customStyles = { item: { smallscreen: {} } },
}: {
  customStyles: { item: { smallscreen: object } };
}) {
  const history = useHistory();
  const location = useLocation();

  const { t } = useContext(TranslationContext) as {
    t: (key: string) => string;
  };

  const classes = styles({
    customStyles,
  });

  const [__, path] = location.pathname.split("/");

  const { product_types, ordered_sections, list_pages } = useSelector(
    (state: {
      WebsiteMetadata: { metadata: { list_pages: { name: string }[] } };
    }) => {
      return {
        product_types: getProductCategoriesSelector(state),
        ordered_sections: getMainPromoGenSectionsSelector(state),
        list_pages: (state?.WebsiteMetadata?.metadata?.list_pages ?? []).map(
          (pg: { name: string }) => pg.name.toLowerCase(),
        ),
      };
    },
  );

  return (
    !ordered_sections.length &&
    linksData.map(
      ([label, pth, srv_type], idx) =>
        product_types.includes(srv_type) &&
        list_pages.includes(label) && (
          <button
            key={`list_page-${idx}-${label}`}
            type="button"
            className={`${classes.item} ${path === pth && classes.selectedItems}`}
            disabled={path === pth}
            onClick={() => history.push(`/${pth}`)}
          >
            {t(label)}
          </button>
        ),
    )
  );
}
ProductTypeSectionsLinks.propTypes = {
  customStyles: PropTypes.object.isRequired,
};

const mobileStyles = createUseStyles({
  menuItem: (props: { customStyles: { menuItem: object } }) => ({
    ...menuItemStyles,
    color: jssVariables.colors.text.light,
    textTransform: "capitalize",
    ...(props?.customStyles?.menuItem ?? {}),
  }),
});
export function ProductTypeSectionsLinksMobile({
  customStyles,
  onHide,
}: {
  customStyles: { menuItem: object };
  onHide: () => void;
}) {
  const history = useHistory();

  const { t } = useContext(TranslationContext) as {
    t: (key: string) => string;
  };

  const classes = mobileStyles({ customStyles });

  const { product_types, ordered_sections, list_pages } = useSelector(
    (state: {
      WebsiteMetadata: { metadata: { list_pages: { name: string }[] } };
    }) => {
      return {
        product_types: getProductCategoriesSelector(state),
        ordered_sections: getMainPromoGenSectionsSelector(state),
        list_pages: (state?.WebsiteMetadata?.metadata?.list_pages ?? []).map(
          (pg: { name: string }) => pg.name.toLowerCase(),
        ),
      };
    },
  );

  function onPush(path: string) {
    history.push(path);
    onHide();
  }

  return (
    !ordered_sections.length &&
    linksData.map(
      ([label, pth, srv_type], idx) =>
        product_types.includes(srv_type) &&
        list_pages.includes(label) && (
          <div
            key={`producttype-${idx}-${label}`}
            className={classes.menuItem}
            onClick={() => onPush(`/${pth}`)}
          >
            <h4>{t(label)}</h4>
          </div>
        ),
    )
  );
}
ProductTypeSectionsLinksMobile.propTypes = {
  customStyles: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
};
